//noinspection JSUnresolvedVariable

/**
 * Handle HMR workflow interface
 */
const $inject = ["$scope", "$interval", "HmrService", "PharmacistService", "MessageService", "eCryptService", "$uibModal"];

class WorkflowController {
  /**
   * @constructor
   * @param $scope
   * @param $interval
   * @param HmrService
   * @param PharmacistService
   * @param MessageService
   * @param eCryptService
   * @param $uibModal
   */
  constructor($scope, $interval, HmrService, PharmacistService, MessageService, eCryptService, $uibModal) {
    this.initialised = false;

    this.$scope = $scope;
    this.$interval = $interval;
    this.hmrService = HmrService;
    this.pharmacistService = PharmacistService;
    /** @var {MessageService} */
    this.messageService = MessageService;
    this.eCryptService = eCryptService;

    this.displayDashboard = false;
    this.displayNewLeads = false;
    this.promise = null;
    this.refreshInterval = 120 * 1000; // Milliseconds

    this.hmrs = null;
    this.pharmacist = null;
    this.preferredForHmr = {};
    this.targetedHmrId = null;

    if (window.globalData && window.globalData.hmrId) {
      this.targetedHmrId = window.globalData.hmrId;
      window.globalData.hmrId = null;
    }

    this.loadingHmrs = false;
    this.loadingPharmacist = true;
    this.getPharmacist();

    // Get the eCrypt encrypting functions
    this.eCryptService.load();

    this.uibModal = $uibModal;
    this.showModal = false;

    // Accordion status set to true in order to open the items by default.
    this.status = {
      newRmmr: true,
      new: true,
      pending: true,
      missed: true,
      accepted: true,
      completed: true,
      refund_request: true,
      cancelled: true,
    };
  }

  /**
   * Retrieve the pharmacist's information
   */
  getPharmacist() {
    this.loadingPharmacist = true;

    // Scope
    var self = this;

    // Callbacks
    var handleSuccess = function (response) {
      self.loadingPharmacist = false;
      if (!response.data.error && response.data.data.pharmacist) {
        self.pharmacist = response.data.data.pharmacist;
        self.documents = response.data.data.documents;
        self.hasReachedMaxThisMonth = response.data.data.hasReachedMaxThisMonth;
        self.hasReachedMaxForMoreThanThreeWeeks = response.data.data.hasReachedMaxForMoreThanThreeWeeks;

        self.product_prices = {};
        for (let price of self.pharmacist.prices) {
          if (!self.product_prices[price.product.referral_type.code]) {
            self.product_prices[price.product.referral_type.code] = {};
          }

          self.product_prices[price.product.referral_type.code][price.product.product_component.code] = +price.price;
        }

        // Notifications and view settings
        self.displayDashboard = false;
        self.displayNewLeads = false;
        var message = null;

        switch (self.pharmacist.status.name) {
          case "accreditation_expired":
            self.messageService.add(
              "danger",
              `Your account is on hold as your accreditation is missing or has expired.\nYou can only view EXISTING referrals.`,
              ["To accept new ones or send completed reports you must update!", "app.pharmacist.documentation"]
            );
            break;
          case "unverified":
            message = "Your account is inactive pending official review.";
            break;
          case "deleted":
            message = "Your account is deleted. Please contact support.";
            break;
          case "suspended":
            self.displayDashboard = true;
            message = "Your account is suspended. Please contact support.";
            break;
          case "incomplete":
            break;
          case "active":
          case "test":
            self.displayDashboard = true;

            if (self.pharmacist.has_uploaded_documentation && self.pharmacist.has_completed_training) {
              self.displayNewLeads = true;
            }

            let certificate_types = {
              hmrCertificate: "Accreditation Certificate",
              ahpraCertificate: "AHPRA Certificate",
              piPlCertificate: "Professional Indemnity & Public Liability Insurance Certificate",
            };

            for (let document of self.documents) {
              if (document.document_expiry && new Date(document.document_expiry) < new Date()) {
                self.messageService.add(
                  "danger",
                  `Your ${certificate_types[document.accreditation_type.name]} has expired.`,
                  ["Please click here to upload a current certificate.", "app.pharmacist.documentation"]
                );
              }
            }

            if (!self.pharmacist.has_uploaded_documentation) {
              self.messageService.add(
                "danger",
                "Your accreditation documentation is incomplete.",
                ["Upload your accreditation documentation.", "app.pharmacist.documentation"]
              );
            }

            if (!self.pharmacist.has_completed_training) {
              self.messageService.add(
                "danger",
                "Your have not completed watching our introductory video.",
                ["Watch the introductory video.", "app.pharmacist.training"]
              );
            }

            if (!self.pharmacist.hasCreditCard) {
              self.messageService.add(
                "danger",
                "Your credit card is not valid or has expired.",
                ["Update your credit card details.", "app.pharmacist.billing"]
              );
            }
            break;
        }

        if (!message) {
          message = response.data.message;
        }

        if (message) {
          self.messageService.add("danger", message);
        }

        // If the dashboard is allowed, load the HMRs
        if (self.displayDashboard) {
          self.startDashboard();
        }
        else {
          self.initialised = true;
        }
      }
      else {
        handleError(response);
      }
    };

    var handleError = function (response) {
      self.loadingPharmacist = false;
      //TODO error handling
    };

    // Call
    this.pharmacistService.get(handleSuccess, handleError, true);
  }

  /**
   * Start dashboard and background refresh
   */
  startDashboard() {
    // Scope
    var self = this;

    // Cancel the automatic refresh feature when leaving the page
    self.$scope.$on("$destroy", function () {
      if (self.promise) {
        self.$interval.cancel(self.promise);
      }
    });

    self.cget();

    // Automatic refresh feature
    self.promise = self.$interval(function () {
      self.cget();
    }, self.refreshInterval);
  }

  /**
   * Get all relevant HMRs for this pharmacist, ordered by category (new, to_do, completed, cancelled...)
   */
  cget() {
    this.loadingHmrs = true;

    // Scope
    var self = this;

    // Callbacks
    var handleSuccess = function (response) {
      self.loadingHmrs = false;
      self.initialised = true;
      if (!response.data.error) {
        self.hmrs = response.data.data.hmrs;
        // If no new leads, determine the explanation message here
        if (!self.hmrs.new.length || !self.displayNewLeads || self.hasReachedMaxThisMonth || self.hasReachedMaxForMoreThanThreeWeeks) {
          self.hasNewLeads = false;
          if (!self.displayNewLeads) {
            switch (self.pharmacist.status.name) {
              case "accreditation_expired":
                self.noNewLeadsMessage = "Your account is on hold. Please update your documents or contact support.";
                break;
              case "suspended":
                self.noNewLeadsMessage = "Your account is suspended. Please contact support.";
                break;
              default:
                self.noNewLeadsMessage = "Your account is currently inactive. You will not receive any new referrals.";
                break;
            }
          }
          else if (self.hasReachedMaxThisMonth) {
            self.noNewLeadsMessage = "Well done! You have reached your maximum referrals this month. You will not receive any new referrals.";
          }
          else if (self.hasReachedMaxForMoreThanThreeWeeks) {
            self.noNewLeadsMessage = "You have at least five referrals that have been open for more than three weeks. They need to be completed in order for you to receive new referrals.";
          }
          // New account (no leads at all)
          else if (!self.hasHmrs()) {
            self.noNewLeadsMessage = "All set up but no referrals yet.";
          }
          else {
            self.noNewLeadsMessage = "No new referrals.";
          }
        }
        else {
          self.hasNewLeads = true;
        }
        // If a specific HMR is targeted (passed in the URL), open it automatically
        if (self.targetedHmrId) {
          self.openByHmrId(self.targetedHmrId);
          // Don't open it again if you refresh the results
          self.targetedHmrId = null;
        }
        self.checkPreferred();
      }
      else {
        handleError(response);
      }
    };

    var handleError = function (response) {
      self.loadingHmrs = false;
      self.initialised = true;
      //TODO error handling
    };

    // Call
    this.hmrService.cget(handleSuccess, handleError);
  }

  pharmacist_is_active() {
    return this.pharmacist.status.name === "active" || this.pharmacist.status.name === "test";
  }

  pharmacist_completed_actions() {
    return this.pharmacist.has_uploaded_documentation && this.pharmacist.has_completed_training && this.pharmacist.hasCreditCard;
  }

  /**
   * Check whether the account has any HMRs at all
   * (If not, the account is considered to be new)
   * @returns {boolean}
   */
  hasHmrs() {
    for (var section in this.hmrs) {
      // Missed leads don't belong to the user so are not checked
      if (section !== "missed" && this.hmrs[section].length > 0) {
        return true;
      }
    }
  }

  /**
   * Check if the current pharmacist is the preferred choice for these HMRs
   */
  checkPreferred() {
    // Scope
    var self = this;

    // Callbacks
    var handleSuccess = function (response) {
      if (!response.data.error) {
        self.preferredForHmr = response.data.data.preferred;
      }
      else {
        handleError(response);
      }
    };

    var handleError = function (response) {
      self.loadingHmrs = false;
      //TODO error handling
    };

    var categories = ["accepted_pending", "cancelled", "completed", "missed", "new", "requested", "to_do"];
    var hmrIds = [];
    for (var c = 0; c < categories.length; c++) {
      for (var i = 0; i < this.hmrs[categories[c]].length; i++) {
        hmrIds.push(this.hmrs[categories[c]][i].id);
      }
    }

    // Call
    if (hmrIds.length > 0) {
      this.hmrService.checkPreferred(hmrIds, handleSuccess, handleError);
    }
  }

  /**
   * Open the modal after a click to accept an HMR
   * @param {Number}  index
   * @param {String}  status
   */
  open(index, status) {
    let hmr = this.hmrs[status][index];

    let prices = {};
    for (let price of this.pharmacist.prices) {
      prices[price.product.code] = price.price;
    }

    let title = (status === "new")? "Accept referral": "";
    this.modal(hmr, title);
  }

  /**
   * Open the modal through URL injection to accept an HMR
   * @param hmr_id
   */
  openByHmrId(hmr_id) {
    let hmrSet = this.hmrs["new"];
    let title = "Accept Lead";

    let prices = {};
    for (let price of this.pharmacist.prices) {
      prices[price.product.code] = price.price;
    }

    // Find the HMR and display the modal
    for (let i = 0; i < hmrSet.length; i++) {
      if (hmrSet[i].id === hmr_id) {
        this.modal(hmrSet[i], title);
        return;
      }
    }

    // If you are still here, that means the HMR hasn't been found, display an error message
    this.errorModal("The HMR could not be found. It has probably already been taken.");
  }

  /**
   * Open the modal
   * @param hmr
   * @param title
   */
  modal(hmr, title) {
    var preferred = (this.preferredForHmr && this.preferredForHmr[hmr.id]);

    var self = this;

    var modal = this.uibModal.open({
      animation: true,
      backdrop: true,
      templateUrl: "hmrAcceptModal.html",
      controller: "HmrAcceptModalController",
      controllerAs: "HmrAcceptCtrl",
      resolve: {
        item: function () {
          return {
            id: hmr.id,
            title: title,
            dateOfLodgement: hmr.dateOfLodgement,
            location: hmr.patientCity + " " + hmr.patientState + " " + hmr.patientPostcode,
            clinic: hmr.practiceName,
            preferred: preferred,
          };
        },
        product_prices: function () {
          return self.product_prices[hmr.referralType.code];
        },
      },
    });

    // Modal outcome
    modal.result.then(function () {
      // Accepted
      // Display confirmation message
      self.messageService.add("success", "Congratulations you've successfully claimed the referral.");
      // Remove accepted lead from dashboard while it's reloading
      var hmrSet = self.hmrs["new"];
      for (var i = 0; i < hmrSet.length; i++) {
        if (hmrSet[i].id === hmr.id) {
          hmrSet.splice(i, 1);
          break;
        }
      }
      // Reload
      self.cget();
    }, function () {
      // Cancelled
    });
  }

  /**
   * Open the error modal
   * @param message
   */
  errorModal(message) {
    this.uibModal.open({
      animation: true,
      backdrop: true,
      templateUrl: "hmrErrorModal.html",
      controller: "HmrErrorModalController",
      controllerAs: "HmrErrorCtrl",
      resolve: {
        message: function () {
          return message;
        },
      },
    });
  }
}

WorkflowController.$inject = $inject;

export default WorkflowController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/features/referral/controllers/workflow.controller.js
 **/